/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_4_IntroInputs */

const en_terms_section_4_intro = /** @type {(inputs: Terms_Section_4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This website exists to explain what we do and how we work. By using it, you agree to:`)
};

const lv_terms_section_4_intro = /** @type {(inputs: Terms_Section_4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šī tīmekļvietne pastāv, lai paskaidrotu, ko un kā mēs darām. To lietojot, Jūs piekrītat:`)
};

/**
* | output |
* | --- |
* | "This website exists to explain what we do and how we work. By using it, you agree to:" |
*
* @param {Terms_Section_4_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_4_intro = /** @type {((inputs?: Terms_Section_4_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_4_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_4_intro(inputs)
	return en_terms_section_4_intro(inputs)
});